<template>
  <div class="app-about-page">
    <app-nav-page-view :tabHoverPage="4"></app-nav-page-view>
    <div class="app-about-banner">
      <app-banner-view
        :titleImageBackground="appAboutBannerImage"
        :titleObj="aboutBannerObj"
      ></app-banner-view>
    </div>
    <div class="about-content-box">
      <div class="about-content flex-middle-x layout-flex-center">
        <ul>
          <li class="flex-middle-x" v-for="(item,index) in aboutList">
            <img :src="item.image" alt="">
            <div>
              <h5>{{item.title}}</h5>
              <p>{{item.content}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="memorabilia-content">
      <app-title-page-view
        :titleObj="MemorabiliaTitleObj"
      ></app-title-page-view>
      <img class="memorabilia-content-time"
           :src="memorabiliaContentTime" alt="">
    </div>
    <div class="location-city">
      <div class="map
      flex-middle-x
      layout-flex-justify-content_space-between"
      @click="actionClickMap">
        <div class="map-title">
          <h5>上海金保证网络科技有限公司</h5>
          <p class="flex-middle-x"><img :src="mapTitle" alt="">上海闵行区宜山路1618号新意城C栋308</p>
        </div>
        <div class="map-router flex-middle-x">
          <span>地图导航</span>
          <img :src="mapRouter" alt="">
        </div>
      </div>
      <div class="location">
        <p>电      话：021-61921322</p>
        <p>客服热线：021-61921322</p>
        <p>邮      箱：pengdashuai@jinbaozheng.com</p>
        <div class="flex-middle-x">
          <p><img :src="wx" alt=""><br><span>官方微信</span></p>
          <p><img :src="app" alt=""><br><span>APP下载</span></p>
        </div>
      </div>
    </div>
    <div class="about-footer">
      <app-footer-page></app-footer-page>
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        appAboutBannerImage: require('./image/app-about-banner-image.png'),
        memorabiliaContentTime: require('./image/memorabilia-content-time.png'),
        mapTitle:require('./image/map-title.png'),
        mapRouter:require('./image/map-router.png'),
        aboutBannerObj:{
          mainHeading:'关于我们',
          subhead:'力致打造行业领导者',
          content:'Shanghai golden guarantee network technology co. LTD'
        },
        MemorabiliaTitleObj:{
          mainHeading:'Memorabilia',
          subhead:'公司大事记',
          content:''
        },
        wx:require('./image/wx.png'),
        app:require('./image/app.png')
      }
    },
    computed:{
      aboutList(){
        return [
          {image:require('./image/client.png'), title:'尊重客户', content:'以客户为中心，用心服务客户；勇于承担企业的责任帮助企业实现目标； 为客户提供卓越的服务体验。'},
          {image:require('./image/science.png'), title:'技术领先', content:'与国际专业协会合作并且高度互动； 前瞻性的引领和满足客户需求；技术和人才的整合，为行业跟随者提供最佳实践； 创造行业最佳实践建立价值观体系。'},
          {image:require('./image/method.png'), title:'方法落地', content:'提供以客户需求为导向的解决方案； 采取多种方式加大企业参与力度； 针对项目不同内容，采取不同的方法协助企业实施落地'}
        ]
      }
    },
    methods:{
      actionClickMap(){
        this.$router.push({name:'AppMapPage'});
      }
    },
    mounted:function(){
      window.scrollTo(0, 0);
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .about-content-box{
    width:100%;
    padding:0.3rem;
    .about-content{
      width:100%;
      ul{
        li{
          text-align: left;
          margin-bottom:0.5rem;
          img{
            width:0.7rem;
          }
          div{
            text-align: justify;
            padding-left:0.2rem;
            h5{
              font-size:0.28rem;
              color:#555555;
              margin-top:0.1rem;
            }
            p{
              font-size:0.24rem;
              color:$color-3;
            }
          }
        }
      }
    }
  }
  .memorabilia-content{
    width:100%;
    background:$color-4;
    .memorabilia-content-time{
      width:100%;
    }
  }
  .about-footer{
    margin-top:0.3rem;
  }
  .location-city{
    width:100%;
    background:$color-4;
    padding:0.44rem 0 0.2rem 0.3rem;
    margin-top:0.2rem;
    .map{
      text-align: left;
      padding-right:0.3rem;
      border-bottom:1px solid #e2e2e2;
      padding-bottom:0.1rem;
      .map-title{
        h5{
          font-size:0.34rem;
          color:$color-black;
        }
        p{
          font-size:0.24rem;
          color:#a6a6a6;
          margin-top:0.1rem;
          img{
            width:0.3rem;
            padding-right:0.1rem;
          }
        }
      }
      .map-router{
        span{
          font-size:0.24rem;
          color:#ffc63d;
          padding-right:0.1rem;
        }
        img{
          width:0.2rem;
        }
      }
    }
    .location{
      width:100%;
      margin:auto;
      text-align: left;
      p{
        font-size:0.24rem;
        color:#a6a6a6;
        margin-top:0.2rem;
      }
      div{
        margin-top:0.4rem;
        p{
          padding-right:0.5rem;
          text-align: center;
          img{
            width:1.3rem;
          }
          span{
            font-size:0.18rem;
            color:$color-black;
          }
        }
      }
    }
  }
</style>
